import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'antd';

interface PlanUpgradePromptProps {
  title?: string;
  description: string;
}

const PlanUpgradePrompt: React.FC<PlanUpgradePromptProps> = ({
  title = 'Upgrade required',
  description,
}) => {
  return (
    <div className="bg-white shadow rounded-lg p-8 text-center max-w-lg mx-auto">
      <h2 className="text-xl font-semibold text-gray-900 mb-2">{title}</h2>
      <p className="text-gray-600 mb-6">{description}</p>
      <Link to="/admin/subscription">
        <Button type="primary" className="bg-blue-500 hover:bg-blue-600">
          View Plans
        </Button>
      </Link>
    </div>
  );
};

export default PlanUpgradePrompt;
